// Map configuration
export const MAPBOX_TOKEN = 'pk.eyJ1IjoibWFuc2VsbGE0MiIsImEiOiJjbWN4Znhhbm4wY29vMmxzYnJ2bWN3ZWg4In0.sK6MlSjsky3eYzmEcfbkog';

// Layer configurations
export const LAYER_CONFIGS = {
  esri: {
    tiles: ['https://services.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}'],
    attribution: '© Esri, ArcGIS Online',
  },
  topo: {
    tiles: ['https://a.tile.opentopomap.org/{z}/{x}/{y}.png'],
    attribution: '© OpenTopoMap',
  },
};

// Feature types
export const FEATURE_TYPES = {
  POLYGON: 'polygon',
  LINESTRING: 'linestring',
  POINT: 'point',
};

// Icon types
export const ICON_TYPES = {
  DEFAULT: 'default',
  TREE_STAND: 'tree-stand',
  BOX_BLIND: 'box-blind',
  FEEDER: 'feeder',
  WATER: 'water',
  CAMP: 'camp',
};

// Default values
export const DEFAULTS = {
  COLOR: '#0d6efd',
  OPACITY: 0.3,
  ICON: 'default',
  MAP_CENTER: [-86.5861, 34.7304],
  MAP_ZOOM: 13,
  MAP_PITCH: 60,
  MAP_BEARING: -15,
  MAX_ZOOM: 24, // Maximum zoom level - fallback handles tile issues
  MIN_ZOOM: 0,  // Minimum zoom level
};

// Page types
export const PAGES = {
  HOME: 'home',
  MAP: 'map',
  CLUBS: 'clubs',
  MESSAGES: 'messages',
  HUNTS: 'hunts',
};
